// Prevent double clicking a link adding the panelPart to the path twice
export const safePanelLink = panelPart =>
  window.location.pathname.endsWith(panelPart) ? window.location.pathname : `${window.location.pathname}/${panelPart}`;

// Prevents double clicking a panel close button removing non-panel parts
export const safePanelUnlink = panelPart => window.location.pathname.replace(`/${panelPart}`, '');
